// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"33df72e5","361":"7a6b6b64","433":"457b6796","511":"9319dfe9","767":"532ff1cf"}[chunkId] + ".chunk.js";
};